export default __webpack_public_path__ + "static/media/icon-document-active.ab959db4.svg";